import { Component, OnInit, Input, OnChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { FinanceService } from 'src/app/modules/dental-office/services/finance/finance.service';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { Chart } from 'chart.js';

@Component({
  selector: 'ark-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.scss']
})
export class ExpenseComponent implements OnInit, OnChanges {

  @Input() year: any = null;
  @ViewChild('barChart') private chartRef;
  chart: any;
  chartUrl: any;
  data: any;
  clinic = null;
  filter = 'expense';

  constructor(
    private finance: FinanceService,
    private auth: AuthService
  ) { }

  ngOnInit() {
    
  }

  ngOnChanges() {
    if(this.year) {
      this.getChart();
    }
  }

  getChart() {
    this.clinic = this.auth.getAuthUser().user_clinic.id;
    this.finance.getFinanceGraph(this.clinic, this.filter, this.year).subscribe(res => {
      if(res) {
        this.data = res;
      }
      this.chart = new Chart(this.chartRef.nativeElement, {
        type: 'bar',
        data: {
          labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          datasets: [
            {
              label: "Expense",
              backgroundColor: "#ff6600",
              borderColor: "#ff6600",
              borderWidth: 1,
              data: [
                this.data['1'].expense,
                this.data['2'].expense,
                this.data['3'].expense,
                this.data['4'].expense,
                this.data['5'].expense,
                this.data['6'].expense,
                this.data['7'].expense,
                this.data['8'].expense,
                this.data['9'].expense,
                this.data['10'].expense,
                this.data['11'].expense,
                this.data['12'].expense,
              ]
            }
          ]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                min: 0,
                maxTicksLimit: 8,
                // Include a peso sign in the ticks
                callback: function(value, index, values) {
                  if(parseInt(value) >= 1000){
                    return '₱ ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  } else {
                    return '₱ ' + value;
                  }
                }
              }
            }],
            xAxes: [{
              barPercentage: 1.0,
              categoryPercentage: 0.5
            }]
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: false
          },
          tooltips: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            callbacks: {
              label: function(tooltipItem, data) {
                return ' ' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }
            },
            xPadding: 10,
            yPadding: 10,
            titleFontFamily: 'News Cycle',
            bodyFontFamily: 'News Cycle',
          },
          animation: {
            onComplete: done
          }
        }
      });

      function done(){
        this.chartUrl = this.chart.canvas.toDataURL();

        localStorage.setItem('chart', this.chartUrl);
      }
    });
  }
}
